import Tbl_user_team from './components/tbl_user_team';
import Tbl_user from './components/tbl_user';
import Tbl_tipocartellino from './components/tbl_tipocartellino';
import Tbl_team from './components/tbl_team';
import Tbl_stagione from './components/tbl_stagione';
import Tbl_sport from './components/tbl_sport';
import Tbl_sostituzione from './components/tbl_sostituzione';
import Tbl_ruolo from './components/tbl_ruolo';
import Tbl_risultato from './components/tbl_risultato';
import Tbl_player from './components/tbl_player';
import Tbl_partita from './components/tbl_partita';
import Tbl_mvpmese from './components/tbl_mvpmese';
import Tbl_mvp from './components/tbl_mvp';
import Tbl_lega_stagione from './components/tbl_lega_stagione';
import Tbl_lega from './components/tbl_lega';
import Tbl_goal from './components/tbl_goal';
import Tbl_formazione from './components/tbl_formazione';
import Tbl_cartellino from './components/tbl_cartellino';
import Tbl_giornata from './components/tbl_giornata';
import Tbl_piani from './components/tbl_piani';

import {
  Admin,
  Resource,
  defaultTheme,
  localStorageStore,
  CustomRoutes
} from 'react-admin';

import Dashboard from './components/dashboard/Dashboard';
import { MyLayout } from "./components/shared/Layout/Layout";

// Setup rotte
import { Route } from 'react-router-dom';

///////////////////////////////
import { restClient, authClient } from 'ra-data-feathers';
import feathersClient from './feathersClient';

// Importo il tema
import { myTheme } from "./components/shared/theme";

// Importo tutti i componenti principali
import { UsersList, UsersCreate, UsersShow } from "./components/users/users";
import { LogList } from './components/logtrack/logtrack';
import ToolsGiornatePage from './components/GiornatePage/ToolsGiornatePage';
import ResetPasswordPage from './components/resetPasswordPage/ResetPasswordPage';

/* Login page custom */
import MyLoginPage from './components/loginpage/MyLoginPage';

/* Not Found page custom */
import NotFoundPage from './components/NotFoundPage/NotFoundPage';

// Decoder per il JWT
import decodeJwt from 'jwt-decode';

import StatisticheBoard from "./components/statistiche/StatisticheBoard";
import SettingsPage from "./components/SettingsPage/SettingsPage";
import ClassificaPage from './components/classifica/ClassificaPage';
import SquadrePage from './components/SquadrePage/SquadrePage';
import PlayersViewPage from './components/PlayersViewPage/PlayersViewPage';
import UsersViewPage from './components/users/UsersViewPage';
import PartitePage from './components/PartitePage/PartitePage';
import PartitaDetailPage from './components/PartitePage/PartitaDetailPage';
import LeghePage from './components/LeghePage/LeghePage';
import LegaDetailPage from './components/LeghePage/LegaDetailPage';
import { SquadreDetailsPage } from './components/SquadrePage/SquadreDetailsPage';
import { SquadreCreatePage } from './components/SquadrePage/SquadreCreatePage';
import { SquadreEditPage } from './components/SquadrePage/SquadreEditPage';
import { PlayersCreatePage } from './components/PlayersViewPage/PlayersCreatePage';
import { PlayersEditPage } from './components/PlayersViewPage/PlayersEditPage';
import { PlayersDetailsPage } from './components/PlayersViewPage/PlayersDetailsPage';
import GiornateCalendarPage from './components/GiornatePage/GiornateCalendarPage';
import GiornataDetailPage from './components/GiornatePage/GiornataDetailPage';
import { StripeTransactionsList, StripeTransactionsShow } from './pages/StripeTransactions';
import SystemHealthPage from './pages/SystemHealthPage';
import PianiPage from './components/tbl_piani/PianiPage';
import { PianiCreatePage } from './components/tbl_piani/PianiCreatePage';
import { PianiEditPage } from './components/tbl_piani/PianiEditPage';
import GruppiPage from './components/tbl_gruppo/GruppiPage';
import { GruppiCreatePage } from './components/tbl_gruppo/GruppiCreatePage';
import { GruppiEditPage } from './components/tbl_gruppo/GruppiEditPage';
import { GruppiDetailPage } from './components/tbl_gruppo/GruppiDetailPage';
import { UsersCreatePage } from './components/users/UsersCreatePage';
import { UsersEditPage } from './components/users/UsersEditPage';
import { UsersDetailPage } from './components/users/UsersDetailPage';
import { Tbl_pianiShow } from './components/tbl_piani/tbl_pianiShow';

/* SETUP COSTANTI GLOBALI - inizio */
import config from '../src/config/config.json';
import { DynamicProcPage } from './components/DynamicProcPage/DynamicProcPage';

const host = config.production.host;
const versione = config.infoapp.versione;
const nome = config.infoapp.nome;
/* SETUP COSTANTI GLOBALI - inizio */

const restClientOptions = {
  id: 'id', // In this example, the database uses '_id' rather than 'id'
  usePatch: true // Use PATCH instead of PUT for updates
};

const options = {
  id: '_id',
  storageKey: 'feathers-jwt', // The key in localStorage used to store the authentication token
  authenticate: { // Options included in calls to Feathers client.authenticate
    strategy: 'local', // The authentication strategy Feathers should use
  },
  permissionsKey: 'permissions', // The key in localStorage used to store permissions from decoded JWT
  permissionsField: 'roles', // The key in the decoded JWT containing the user's role
  passwordField: 'password', // The key used to provide the password to Feathers client.authenticate
  usernameField: 'email', // The key used to provide the username to Feathers client.authenticate
  redirectTo: '/login', // Redirect to this path if an AUTH_CHECK fails. Uses the react-admin default of '/login' if omitted.
  logoutOnForbidden: true, // Logout when response status code is 403
  /* Allows to use custom query operators from various feathers-database-adapters in GET_MANY calls.
 * Will be merged with the default query operators ['$gt', '$gte', '$lt', '$lte', '$ne', '$sort', '$or', '$nin', '$in']
 */
  customQueryOperators: ['$gt', '$gte', '$lt', '$lte', '$ne', '$sort', '$or', '$nin', '$in']

}

export const theme = {
  ...defaultTheme,
  overrides: {
    /*     RaSidebar: {
          drawerPaper: {
            width: 300,
          },
          fixed: {
            zIndex: 1200,
          },
        }, */
    RaSidebar: {
      fixed: {
        position: 'inherit'
      }
    },
  },
};

// Init store
const storeGenerale = localStorageStore();

// Debug per problema con ra_calendar
const feathersDataProvider = restClient(feathersClient, restClientOptions);

const myDataProvider = async (verb, resource, params) => {
  const result = await feathersDataProvider(verb, resource, params);
  if (resource === 'events') {
    console.log(":::: DEBUG START :::: EVENTS");
    const service = feathersClient.service(resource);
    const query = {}; // Build your query here
    const risultato = service.find({ query });
    //TODO: devo chiedere a feathersjs che ruolo ha lo user con l'email specificata
    console.log(resource, risultato);
    return risultato;
  }
  return result;
}

const feathersAuthProvider = authClient(feathersClient, options);
const myAuthProvider = async (verb, resource, params) => {
  const result = await feathersAuthProvider(verb, resource, params);

  if (typeof (resource) != "undefined") {
    try {
      if (typeof (resource['username']) != "undefined") {

        // Reset variabili
        storeGenerale.setItem('profile.name', "");
        storeGenerale.setItem('profile.roles', "");

        // console.log(":::: DEBUG START AUTH ::::");
        // console.log(resource);
        // console.log(resource['username']);
        var test = localStorage.getItem("feathers-jwt");
        const decodedToken = decodeJwt(test);
        // console.log("---- token decodificato ----");
        // console.log("---- token decodificato ----", decodedToken);
        // console.log(localStorage.getItem('permissions'));
        storeGenerale.setItem('profile.name', decodedToken.username);
        storeGenerale.setItem('profile.email', decodedToken.email);
        storeGenerale.setItem('profile.roles', decodedToken.roles);
        storeGenerale.setItem('profile.idUser', decodedToken.id);
        // storeGenerale.setItem('profile.ruolo','admin');
        // console.log(":::: DEBUG STOP AUTH ::::");
      }
    } catch (error) {
      console.log(error);
    }
  }

  return result;
}

/* --- */



const App = () => {

  return (
    <Admin
      title={nome + " " + versione}
      catchAll={NotFoundPage}
      store={storeGenerale}
      layout={MyLayout} // Include il menu
      dashboard={Dashboard} // TODO: SISTEMA LA GRAFICA
      loginPage={MyLoginPage}
      theme={myTheme}
      dataProvider={myDataProvider}
      authProvider={myAuthProvider}
    >
      {permissions => [
        permissions === 'admin' ?
          <>
            {<CustomRoutes >
              <Route exact path="/dynamicproc" element={<DynamicProcPage />} />
            </CustomRoutes>}

            <Resource name="tbl-cartellino" {...Tbl_cartellino} />
            <Resource name="tbl-formazione" {...Tbl_formazione} />
            <Resource name="tbl-goal" {...Tbl_goal} />
            <Resource name="tbl-lega" {...Tbl_lega} />
            <Resource name="tbl-lega-stagione" {...Tbl_lega_stagione} />
            <Resource name="tbl-giornata" {...Tbl_giornata} />
            <Resource name="tbl-mvp" {...Tbl_mvp} />
            <Resource name="tbl-mvpmese" {...Tbl_mvpmese} />
            <Resource name="tbl-partita" {...Tbl_partita} />
            <Resource name="tbl-player" {...Tbl_player} />
            <Resource name="tbl-risultato" {...Tbl_risultato} />
            <Resource name="tbl-ruolo" {...Tbl_ruolo} />
            <Resource name="tbl-sostituzione" {...Tbl_sostituzione} />
            <Resource name="tbl-sport" {...Tbl_sport} />
            <Resource name="tbl-stagione" {...Tbl_stagione} />
            <Resource name="tbl-team" {...Tbl_team} />
            <Resource name="tbl-tipocartellino" {...Tbl_tipocartellino} />
            <Resource name="tbl-piani" {...Tbl_piani} />
            <Resource name="tbl-user" {...Tbl_user} />
            <Resource name="tbl-user-team" {...Tbl_user_team} />

            <Resource
              name="tbl-transactions"
              list={StripeTransactionsList}
              show={StripeTransactionsShow}
              options={{ label: 'Transazioni Stripe' }}
            />

            {/* Gestione Utenti con nuova grafica */}
            <Resource name="users"
              list={UsersList}
              create={UsersCreate}
              show={UsersShow}
            />

            {<Resource name="tbl-messaggi"
            />}


            {<Resource name="logtrack"
              list={LogList}
            />}

            {<Resource name="users-collaboratori"
            />}

            {<Resource name="users-collaboratori-candidati"
            />}

            {<CustomRoutes >
              <Route exact path="/statistiche" element={<StatisticheBoard />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/settingspage" element={<SettingsPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/classifica" element={<ClassificaPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/tools-giornate" element={<ToolsGiornatePage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/squadre" element={<SquadrePage />} />
              <Route exact path="/squadre/:teamId" element={<SquadreDetailsPage />} />
              <Route exact path="/squadre/create" element={<SquadreCreatePage />} />
              <Route exact path="/squadre/:teamId/edit" element={<SquadreEditPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/giocatori" element={<PlayersViewPage />} />
              <Route exact path="/giocatori/:playerId" element={<PlayersDetailsPage />} />
              <Route exact path="/giocatori/create" element={<PlayersCreatePage />} />
              <Route exact path="/giocatori/:playerId/edit" element={<PlayersEditPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/users-view" element={<UsersViewPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/partite" element={<PartitePage />} />
              <Route exact path="/partite/:partitaId" element={<PartitaDetailPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/giornate-calendario" element={<GiornateCalendarPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/giornate/:giornataId" element={<GiornataDetailPage />} />
              <Route exact path="/leghe" element={<LeghePage />} />
              <Route exact path="/leghe/:legaId" element={<LegaDetailPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/system-health" element={<SystemHealthPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/piani" element={<PianiPage />} />
              <Route exact path="/piani/create" element={<PianiCreatePage />} />
              <Route exact path="/piani/:pianoId/edit" element={<PianiEditPage />} />
              <Route exact path="/piani/:id/show" element={<Tbl_pianiShow />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/gruppi" element={<GruppiPage />} />
              <Route exact path="/gruppi/create" element={<GruppiCreatePage />} />
              <Route exact path="/gruppi/:gruppoId" element={<GruppiDetailPage />} />
              <Route exact path="/gruppi/:gruppoId/edit" element={<GruppiEditPage />} />
            </CustomRoutes>}

            {<CustomRoutes >
              <Route exact path="/users/create" element={<UsersCreatePage />} />
              <Route exact path="/users/:userId" element={<UsersDetailPage />} />
              <Route exact path="/users/:userId/edit" element={<UsersEditPage />} />
            </CustomRoutes>}

          </> : <>


          </>]}



      {<CustomRoutes noLayout>
        <Route exact path="/resetpassword/" element={<ResetPasswordPage />} />
        <Route exact path="/resetpassword/:hash" element={<ResetPasswordPage />} />
      </CustomRoutes>}

      {/*   {<Resource name="users"
        list={UsersList}
        create={UsersCreate}
        show={UsersShow}
      />}

      {<Resource name="tbl-macroaree"
        list={MacroareeList}
        edit={MacroareeEdit}
        show={MacroareeShow}
      />}

      {<Resource name="tbl-macroarea-punteggio"
      />}

      {<Resource name="tbl-quiz-domande"
      />}

      {<Resource name="tbl-quiz"
      />}

      {<Resource name="view-domande-for-gen"
      />}

      {<Resource name="view-quiz-avanzamento"
      />}


      {<Resource name="tbl-domande"
        list={DomandeList}
        edit={DomandeEdit}
        show={DomandeShow}
      />}


      {<CustomRoutes >
        <Route exact path="/statistiche" element={<StatisticheBoard />} />
      </CustomRoutes>}

      {<CustomRoutes >
        <Route exact path="/settingspage" element={<SettingsPage />} />
      </CustomRoutes>} */}

    </Admin>
  );
}

export default App;